import { faker } from '@faker-js/faker/locale/ru'
import { CitizenSex, Citizen, calcCitizenCategory, CitizenCategory } from './citizens'
import { RealDateTimeProvider, UuidIdGenerator } from '../../../common'
import { times } from 'lodash'

export function mockCitizen(opts?: Partial<Citizen>): Citizen {
  const sex = faker.person.sexType()
  const birthdate = faker.date.past({ years: faker.number.int({ min: 1, max: 80 }) })
  const idGenerator = new UuidIdGenerator()
  const dateTimeProvider = new RealDateTimeProvider()

  const citizen: Citizen = {
    id: idGenerator.generate(),
    surname: faker.person.lastName(sex),
    name: faker.person.firstName(sex),
    patronymic: faker.person.middleName(sex),
    sex: sex === 'male' ? CitizenSex.MALE : CitizenSex.FEMALE,
    birthdate: birthdate,
    phone: faker.phone.number('7##########'),
    municipalEntityId: idGenerator.generate(),
    locality: faker.location.city(),
    street: faker.location.street(),
    house: faker.location.buildingNumber(),
    appartment: `${faker.number.int({ min: 0, max: 250 })}`,
    category: CitizenCategory.CH,
    createdAt: dateTimeProvider.get(),
    guardianIds: times(faker.number.int({ min: 0, max: 3 }), () => idGenerator.generate()),
    dependentIds: times(faker.number.int({ min: 0, max: 3 }), () => idGenerator.generate()),
    ...opts,
  }
  citizen.category = calcCitizenCategory(citizen.sex, citizen.birthdate)
  return citizen
}
